import { render, staticRenderFns } from "./RecipientListItem.vue?vue&type=template&id=75c5bdd4&scoped=true"
import script from "./RecipientListItem.vue?vue&type=script&lang=js"
export * from "./RecipientListItem.vue?vue&type=script&lang=js"
import style0 from "./RecipientListItem.vue?vue&type=style&index=0&id=75c5bdd4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c5bdd4",
  null
  
)

export default component.exports